import { combineReducers } from "redux";
import tournaments from "./tournaments";
import matches from "./matches";
import visorias from "../../screens/VisoriasScreen/redux/reducer";
import searchPlayer from "../../screens/SearchPlayerScreen/redux/reducers";
import strikerPlayer from "../../screens/StrikerScreen/redux/reducer";
import teams from "./teams";
import assisterPlayer from "../../screens/AssitersScreen/redux/reducers";

export default function createReducer(){
    return combineReducers({
        tournaments,
        matches,
        visorias,
        searchPlayer,
        strikerPlayer,
        teams,
        assisterPlayer
        
    })
}